// extracted by mini-css-extract-plugin
module.exports = {"inputField":"style_inputField__1aA5l","label":"style_label__Y3-7y"};